import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PublicLayout from "@/components/public/PublicLayout";
import BlockRenderer from "@/components/public/BlockRenderer";
import { ArrowRight } from "lucide-react";

export default function Home() {
  const [page, setPage] = useState(undefined);

  useEffect(() => {
    api.get("/public/home").then((r) => setPage(r.data)).catch(() => setPage(null));
    document.title = "EmotionalSignal";
  }, []);

  useEffect(() => {
    if (page?.seo?.meta_title) document.title = page.seo.meta_title;
  }, [page]);

  return (
    <PublicLayout>
      {page === undefined ? (
        <div className="min-h-screen flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-black/20 border-t-black rounded-full animate-spin" />
        </div>
      ) : page && page.blocks?.length ? (
        <BlockRenderer blocks={page.blocks} />
      ) : (
        <div className="min-h-[92vh] flex items-center justify-center px-6">
          <div className="text-center max-w-lg">
            <p className="font-body text-xs uppercase tracking-[0.3em] text-[#999] mb-6">EmotionalSignal</p>
            <h1 className="font-display text-5xl lg:text-6xl font-bold tracking-tighter leading-none mb-6">
              The website is coming to life.
            </h1>
            <p className="font-body font-light text-[#555] mb-10">
              No homepage has been published yet. Sign in to the editor to build and publish your brand.
            </p>
            <Link to="/editor" data-testid="home-to-editor"
                  className="inline-flex items-center gap-2 bg-[#0A0A0A] text-white px-7 py-3.5 rounded-full font-body font-medium hover:-translate-y-1 hover:shadow-xl transition-transform">
              Open the editor <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      )}
    </PublicLayout>
  );
}
